import ChessPuzzle from "../Views/Chess";

const routes = [{ path: "/chess-puzzle", element: <ChessPuzzle /> }];

export default routes;
